function getComponentByPath(path, pageModel) {
    const componentNames = path.split('/');
    if (!(pageModel === null || pageModel === void 0 ? void 0 : pageModel.page) || !componentNames) {
        return;
    }
    let component = pageModel.page;
    while(componentNames.length && component){
        var ref;
        const name = componentNames.shift();
        component = component === null || component === void 0 ? void 0 : (ref = component.components) === null || ref === void 0 ? void 0 : ref.find((c)=>c.name === name
        );
    }
    return component;
}

export { getComponentByPath };
//# sourceMappingURL=get-component-by-path.js.map
